import Image from 'next/image'

import Box from '@totallymoney/ui/components/Box'
import Flex from '@totallymoney/ui/components/Flex'
import Grid from '@totallymoney/ui/components/Grid'
import Heading from '@totallymoney/ui/components/Heading'
import Row from '@totallymoney/ui/components/Row'
import Stack from '@totallymoney/ui/components/Stack'
import Text from '@totallymoney/ui/components/Text'
import Icon from '@totallymoney/ui/icons/Icon'

import BackgroundImageRenderer from '@components/BackgroundImageRenderer'

import useAppQueryState from '@hooks/useAppQueryState'

import CategoryPageHeroBackgroundMobile from '@images/credit-cards-landing-page-hero-background-mobile.png'
import CategoryPageHeroBackgroundTabletPlus from '@images/credit-cards-landing-page-hero-background.png'
import CategoryPageHeroImage from '@images/creditcards-hero@2x.png'

import UnscoredButton from '../UnscoredButton'
import { StyledHeroWrapper } from './UnscoredHero.styled'
import heroData from './lib/heroData'

const UnscoredHero = () => {
    const { appQueryState } = useAppQueryState()

    const category = appQueryState.categoryId!

    return (
        <StyledHeroWrapper
            as="section"
            position="relative"
            display="flex"
            backgroundColor="indigo60"
            waveColor="#FFFFFF"
        >
            <BackgroundImageRenderer
                altText="Hero background"
                backgroundMobile={CategoryPageHeroBackgroundMobile}
                backgroundTabletPlus={CategoryPageHeroBackgroundTabletPlus}
                priority
            />

            <Box
                pt={['space40', 'space40', 'space80']}
                pb="space80"
                width="100%"
                zIndex={2}
            >
                <Grid>
                    <Stack
                        gridColumn={['1/13', '1/7']}
                        gridRow={[2, 1]}
                        mb={['space30', 0]}
                        space={['space30', 'space40']}
                    >
                        <Heading variant="140" color="white">
                            {heroData[category].title}
                        </Heading>

                        <Flex justifyContent={['center', 'flex-start']}>
                            <UnscoredButton
                                variant="tertiary"
                                text="Check my eligibility"
                            />
                        </Flex>

                        <Stack space="space15">
                            {heroData[category].bullets.map((bullet, i) => (
                                <Row
                                    space="space10"
                                    alignItems="center"
                                    key={`${bullet}-${i}`}
                                >
                                    <Flex aria-hidden alignItems="center">
                                        <Icon
                                            icon="checkmark"
                                            size={16}
                                            color="white"
                                        />
                                    </Flex>

                                    <Text color="white" variant="120">
                                        {bullet}
                                    </Text>
                                </Row>
                            ))}
                        </Stack>
                    </Stack>

                    <Flex
                        gridColumn={['1/13', '7/13']}
                        gridRow={1}
                        alignItems="center"
                        justifyContent={['center', 'flex-end']}
                    >
                        <Box maxWidth="424px" width="100%">
                            <Image
                                src={CategoryPageHeroImage}
                                alt="Happy person with cards"
                                quality={60}
                                priority={true}
                                placeholder="empty"
                                width={424}
                                sizes="424px"
                                style={{
                                    zIndex: 1,
                                    objectFit: 'contain',
                                    width: '100%',
                                    height: 'auto',
                                }}
                            />
                        </Box>
                    </Flex>
                </Grid>
            </Box>
        </StyledHeroWrapper>
    )
}

export default UnscoredHero
